( function( $ ) {
	$( '.js-hamburger-icon' ).on( 'click', function() {
		$( '.js-hamburger-icon' ).toggleClass( 'is-active' );
	} );
}( jQuery ) );



// WEBPACK FOOTER //
// ./source/js/components/hamburger-icon.js